import { Route, Switch } from 'wouter';
import { AuthedPage } from '../../../app';
import { OrganizationChallengeOne } from './ChallengeOne';
import { OrganizationChallengeTwo } from './ChallengeTwo';
import { OrganizationChallengeThree } from './ChallengeThree';

export const BusinessChallengesForm = () => {
  return (
    <AuthedPage>
      <Switch>
        <Route path='/1'>
          <OrganizationChallengeOne />
        </Route>
        <Route path='/2'>
          <OrganizationChallengeTwo />
        </Route>
        <Route path='/3'>
          <OrganizationChallengeThree />
        </Route>
      </Switch>
    </AuthedPage>
  );
};

export default BusinessChallengesForm;
